<template>
    <el-select v-model="selectedSite" :placeholder="placeholder" @change="handleChange">
        <el-option v-if="isSearchModel" label="すべて" :value="ALL"/>
        <el-option v-for="item in sites" :key="item.site_code" :label="item.site_name" :value="item.site_code" />
    </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import axios from 'axios';
import { SiteInfo } from '@/components/models/siteinfo';
import { ALL } from '@/config/constants';

export default defineComponent({
    name: 'SiteSelector',
    props: {
        isSearch: {
            type: Boolean,
            default: false,
        },
        company_code: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            default: ALL,
        },
        placeholder: {
            type: String,
            default: '現場名を選択してください',
        },
    },

    emits: ['update:modelValue', 'change'],

    setup(props, { emit }) {
        const sites = ref<SiteInfo[]>([]);
        const selectedSite = ref(props.modelValue);
        const isSearchModel = ref(props.isSearch);

        onMounted(() => {
            if (!props.company_code) {
                sites.value = [];
                return;
            }
            fetchSites();
        });

        // 监听 company_code 的变化，重新获取站点列表

        watch(() => props.company_code, async (newValue, oldValue) => {
            if (newValue === oldValue) return;
            // 清空站点列表
            sites.value = [];
            // 保存旧的modelValue
            const oldModelValue = props.modelValue;

            if (newValue) {
                // 获取新的用户列表
                await fetchSites();

                // 如果旧的modelValue存在，则检查新的用户列表中是否包含旧的modelValue对应的用户
                if (oldModelValue) {
                    const siteExists = sites.value.some(site => site.site_code === oldModelValue);
                    if (siteExists) {
                        // 如果存在，则设置选中值
                        selectedSite.value = oldModelValue;
                        emit('update:modelValue', oldModelValue);
                    } else {
                        // 如果不存在，则清空选中值
                        selectedSite.value = isSearchModel.value ? ALL : '';
                        emit('update:modelValue', isSearchModel.value ? ALL : '');
                    }
                } else {
                    // 如果旧的modelValue不存在，则清空选中值
                    selectedSite.value = isSearchModel.value ? ALL : '';
                    emit('update:modelValue', isSearchModel.value ? ALL : '');
                }
            }

        });


        // 监听 modelValue 的变化，更新选中值
        watch(() => props.modelValue, (newValue) => {
            // 只有当新值与当前选中值不同时才更新
            if (selectedSite.value !== newValue) {
                selectedSite.value = newValue;
            }
        });

        const handleChange = (value: string) => {
            emit('update:modelValue', value);
            emit('change', value);
        };

        const fetchSites = async () => {
            try {
                const response = await axios.get(`/api/sites?company_code=${props.company_code}`);
                sites.value = response.data.data;
                // 确保在获取数据后更新选中值
                if (props.modelValue && !selectedSite.value) {
                    selectedSite.value = props.modelValue;
                }
            } catch (error) {
                // console.error('获取组织列表失败:', error);
            }
        };


        return {
            sites,
            selectedSite,
            handleChange,
            ALL,
            isSearchModel,
        };
    },
});
</script>